<template>
  <b-modal
    id="modal-criar-representante"
    title="Novo Representante"
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
    @hidden="resetForm"
  >
    <validation-observer ref="formObserver">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12" md="4" class="mb-1">
            <b-form-group label="Código *" label-for="rc-id">
              <validation-provider #default="{ errors }" name="Código" rules="required">
                <b-form-input
                  id="rc-id"
                  v-model="form.representanteid"
                  placeholder="Ex: 200"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="8" class="mb-1">
            <b-form-group label="Nome completo *" label-for="rc-nome">
              <validation-provider #default="{ errors }" name="Nome" rules="required">
                <b-form-input
                  id="rc-nome"
                  v-model="form.representantenome"
                  placeholder="Nome completo do representante"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-1">
            <b-form-group label="Nome abreviado *" label-for="rc-nomeabr">
              <validation-provider #default="{ errors }" name="Nome abreviado" rules="required">
                <b-form-input
                  id="rc-nomeabr"
                  v-model="form.representantenomeabreviado"
                  placeholder="Ex: GRECO"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-1">
            <b-form-group label="E-mail" label-for="rc-email">
              <b-form-input
                id="rc-email"
                v-model="form.representanteemail"
                type="email"
                placeholder="email@exemplo.com.br"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" class="mb-1">
            <b-form-group label="Comissão (%)" label-for="rc-comissao">
              <b-form-input
                id="rc-comissao"
                v-model="form.representantepercentualcomissao"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" class="mb-1">
            <b-form-group label="Seq. Pedido" label-for="rc-seq">
              <b-form-input
                id="rc-seq"
                v-model="form.representanteseqpedido"
                type="number"
                min="0"
                placeholder="0"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" class="mb-1 d-flex align-items-center" style="padding-top:18px">
            <b-form-checkbox v-model="form.representanteativo" switch>
              Ativo
            </b-form-checkbox>
          </b-col>

          <b-col cols="12" class="mb-1">
            <b-form-group label="Endereço" label-for="rc-end">
              <b-form-input
                id="rc-end"
                v-model="form.representanteendereco"
                placeholder="Rua, número"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" class="mb-1">
            <b-form-group label="Bairro" label-for="rc-bairro">
              <b-form-input id="rc-bairro" v-model="form.representantebairro" placeholder="Bairro" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" class="mb-1">
            <b-form-group label="Cidade" label-for="rc-cidade">
              <b-form-input id="rc-cidade" v-model="form.representantecidade" placeholder="Cidade" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="2" class="mb-1">
            <b-form-group label="UF" label-for="rc-uf">
              <b-form-input id="rc-uf" v-model="form.ufid" placeholder="SP" maxlength="2" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="2" class="mb-1">
            <b-form-group label="País ID" label-for="rc-pais">
              <b-form-input id="rc-pais" v-model="form.paisid" placeholder="1" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <template #modal-footer>
      <b-button variant="secondary" @click="$bvModal.hide('modal-criar-representante')">
        Cancelar
      </b-button>
      <b-button variant="success" :disabled="salvando" @click="salvar">
        <b-spinner v-if="salvando" small class="mr-1" />
        {{ salvando ? 'Salvando...' : 'Salvar' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox,
  BButton, BSpinner,
} from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { required } from '@validations';
import SLSRepresentanteService from '@/services/Cadastros/ApoioVendas/SLSRepresentante.service';

export default {
  name: 'ModalCriarRepresentante',
  components: {
    BModal, BForm, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox,
    BButton, BSpinner, ValidationObserver, ValidationProvider,
  },
  data() {
    return {
      salvando: false,
      form: this.emptyForm(),
      service: new SLSRepresentanteService(),
      required,
    };
  },
  methods: {
    emptyForm() {
      return {
        representanteid: '',
        representantenome: '',
        representantenomeabreviado: '',
        representanteemail: '',
        representantepercentualcomissao: 0,
        representanteseqpedido: 0,
        representanteativo: true,
        representanteendereco: '',
        representantebairro: '',
        representantecidade: '',
        ufid: '',
        paisid: '1',
      };
    },
    resetForm() {
      this.form = this.emptyForm();
      this.salvando = false;
      if (this.$refs.formObserver) this.$refs.formObserver.reset();
    },
    async salvar() {
      const valid = await this.$refs.formObserver.validate();
      if (!valid) return;
      this.salvando = true;
      try {
        await this.service.store(this.form);
        this.$bvModal.hide('modal-criar-representante');
        this.$bvToast.toast('Representante criado com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });
        this.$emit('criado');
      } catch (e) {
        this.$bvToast.toast('Erro ao criar representante. Verifique os dados.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>
